export const shouldRenderAuthRoot = ({ useConvexAuth }, forceLocalMode) => (
  Boolean(useConvexAuth) && !forceLocalMode
);
